/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { Fragment } from "react/jsx-runtime";
import { TreeCollapsible } from "../tree-collapsible";
import { useState } from "react";
import { arrayMoveImmutable } from "array-move";
import { useResetTreeSelect } from "@/global-data/use-reset-tree-select";

export const TreeStructureEntity = ({
  data,
  treeId,
  config,
  setActiveRef,
  parentKey,
  onTreeChange,
  onTreeMutation,
  onTreeFormSubmit,
  erpListData,
  orderTypeList,
  parentOrderType,
  sortingTree,
  support_multi_doc_type,
}: {
  data: any;
  erpListData: string[];
  treeId: any;
  parentOrderType?: any;
  config: any;
  sortingTree: any;
  setActiveRef: any;
  parentKey: string;
  orderTypeList: any;
  onTreeChange: (prop: any) => void;
  onTreeMutation: (prop: any) => void;
  onTreeFormSubmit: (prop: any, prop2?: any) => void;
  support_multi_doc_type: boolean;
}) => {
  const { setIsReset, setDragParentId, dragParentId } = useResetTreeSelect();
  const [dragStartIndex, setDragStartIndex] = useState("");
  const [hoverIndex, setHoverIndex] = useState<any>("");
  const dargStart = (_e: any, dIndex: any) => {
    setDragStartIndex(String(dIndex));
    setHoverIndex(null);
    // console.log("start:", e);
  };

  // const dragEnd = (_e: any /* , dragEndIndex: any */) => {
  //   const endIndex = hoverIndex; // <- where we dropped/last hovered
  //   setDragStartIndex("");
  //   setHoverIndex(null);
  //   const newArray = arrayMoveImmutable(
  //     data?.attributes,
  //     +dragStartIndex,
  //     +endIndex
  //   );
  //   setIsReset(true);

  //   sortingTree({
  //     parentKey,
  //     newArray,
  //     treeId,
  //   });
  // };

  const dragEnd = (_e: any) => {
    const endIndex = hoverIndex ?? dragStartIndex; // fallback if no hover
    setDragStartIndex("");
    setHoverIndex(null);

    const newArray = arrayMoveImmutable(
      data?.attributes,
      +dragStartIndex,
      +endIndex
    );
    setIsReset(true);

    setDragParentId(undefined);

    sortingTree({ parentKey, newArray, treeId });
  };

  return (
    <Fragment>
      <ConditionRenderer condition={data.type === "entity"}>
        <TreeCollapsible
          setActiveRef={setActiveRef}
          config={config}
          name={data.name}
          orderTypeList={orderTypeList}
          type={data.type}
          parentKey={parentKey}
          onTreeChange={onTreeChange}
          erpListData={erpListData}
          entityCardinality={data.cardinality}
          document_types={data.document_types}
          onTreeMutation={(prop: any) => {
            onTreeMutation(prop);
          }}
          treeId={treeId}
          count={data?.attributes?.length}
          defaultOpen={true}
          onTreeFormSubmit={onTreeFormSubmit}
          parentOrderType={parentOrderType}
          support_multi_doc_type={support_multi_doc_type}
        >
          {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
          <div>
            {data?.attributes?.map((item: any, index: number) => {
              const pathIndex = `${parentKey}.attributes.${index}`; // <-- unique per node

              return (
                <div
                  key={pathIndex}
                  draggable
                  onDragStart={(e) => {
                    e.stopPropagation(); // 🚫 don't bubble to parents
                    dargStart(e, index);
                    setDragParentId(parentKey); // ✅ mark THIS list as the owner
                  }}
                  onDragEnter={(e) => {
                    e.preventDefault();
                    if (dragParentId !== parentKey) return; // ✅ only react inside owner list
                    setHoverIndex(String(index));
                  }}
                  onDragOver={(e) => {
                    if (dragParentId !== parentKey) return; // ✅ scope to owner list
                    e.preventDefault();
                  }}
                  onDragLeave={(e) => {
                    if (dragParentId !== parentKey) return; // ✅ scope to owner list
                    const related = e.relatedTarget as Node | null;
                    if (!related || !e.currentTarget.contains(related)) {
                      if (hoverIndex === String(index)) setHoverIndex(null);
                    }
                  }}
                  onMouseDown={(e) => {
                    e.stopPropagation(); // 🚫 prevent parents from overriding
                    setDragParentId(parentKey); // (still OK to keep for safety)
                  }}
                  onDragEnd={(e) => {
                    e.stopPropagation(); // 🚫 don't let parents fire theirs
                    if (dragParentId !== parentKey) return; // ✅ only this list finalizes
                    dragEnd(e);
                  }}
                  style={{
                    outline:
                      hoverIndex === String(index)
                        ? "1px solid green"
                        : undefined,
                    transition: "padding-bottom 120ms ease",
                  }}
                >
                  <TreeStructureEntity
                    setActiveRef={setActiveRef}
                    config={config}
                    key={index}
                    data={item}
                    orderTypeList={orderTypeList}
                    erpListData={erpListData}
                    sortingTree={sortingTree}
                    onTreeChange={onTreeChange}
                    parentOrderType={parentOrderType}
                    parentKey={parentKey + ".attributes." + index}
                    onTreeMutation={(prop: any) => {
                      onTreeMutation(prop);
                    }}
                    treeId={treeId}
                    onTreeFormSubmit={onTreeFormSubmit}
                    support_multi_doc_type={support_multi_doc_type}
                  />
                </div>
              );
            })}
          </div>
        </TreeCollapsible>
      </ConditionRenderer>
      <ConditionRenderer condition={data.type === "attribute"}>
        <TreeCollapsible
          config={config}
          name={data.name}
          type={data.type}
          orderTypeList={orderTypeList}
          jsonData={{ synonyms: data.synonyms }}
          data_type={data.data_type}
          setActiveRef={setActiveRef}
          parentKey={parentKey + ".synonyms"}
          onTreeChange={onTreeChange}
          erp_mapping_value={data.erp_mapping}
          cardinality={data.cardinality}
          document_types={data.document_types}
          erpListData={erpListData}
          onTreeMutation={(prop: any) => {
            onTreeMutation(prop);
          }}
          treeId={treeId}
          defaultOpen={true}
          onTreeFormSubmit={onTreeFormSubmit}
          parentOrderType={parentOrderType}
          support_multi_doc_type={support_multi_doc_type}
        >
          <></>
        </TreeCollapsible>
      </ConditionRenderer>
      <ConditionRenderer condition={data.domain_name}>
        <TreeCollapsible
          config={config}
          name={data.domain_name}
          type={"domain"}
          domainType={data.type}
          setActiveRef={setActiveRef}
          parentKey={parentKey}
          orderTypeList={orderTypeList}
          onTreeChange={onTreeChange}
          erpListData={erpListData}
          onTreeMutation={(prop: any) => {
            onTreeMutation(prop);
          }}
          treeId={treeId}
          order_type={data.order_type}
          count={data?.entities?.length}
          defaultOpen={true}
          onTreeFormSubmit={onTreeFormSubmit}
          support_multi_doc_type={support_multi_doc_type}
        >
          {data?.entities?.map((item: any, index: number) => {
            return (
              <TreeStructureEntity
                setActiveRef={setActiveRef}
                config={config}
                key={index}
                data={item}
                orderTypeList={orderTypeList}
                erpListData={erpListData}
                sortingTree={sortingTree}
                parentOrderType={data.order_type}
                parentKey={parentKey + ".entities." + index}
                onTreeChange={onTreeChange}
                onTreeMutation={(prop: any) => {
                  onTreeMutation(prop);
                }}
                treeId={treeId}
                onTreeFormSubmit={onTreeFormSubmit}
                support_multi_doc_type={support_multi_doc_type}
              />
            );
          })}
        </TreeCollapsible>
      </ConditionRenderer>
    </Fragment>
  );
};
